
















import { Component, Vue } from 'vue-property-decorator'
import VideoPointsManage from '@/components/videoDevice/form/point/popManage.vue'
import videoPointForm from '@/components/videoDevice/form/point/form.vue'
import FocusVideoPoints from '@/components/videoDevice/view/focusList.vue'
import VideoList from './list/deviceList.vue'
import PointList from './list/pointList.vue'

import { tryToStr } from '@/configs/functions'

@Component({
  components: {
    VideoList, PointList, FocusVideoPoints, VideoPointsManage, videoPointForm
  }
})
export default class VideoManage extends Vue {
  public $refs!: {
    videoCtrl: VideoList
    pointCtrl: PointList
  }
  public tabName: string = 'tabDevice'
  public tabClick(tab: any) {
    this.tabName = tab.name
    this.loadData()
  }
  public created() {
    const query = this.$route.query
    var tab = tryToStr(query['tab'])
    if (tab == 'point') {
      this.tabName = 'tabPoint'
    }
    else {
      this.tabName = 'tabDevice'
    }
  }
  public mounted() {
    this.loadData()
  }
  public loadData() {
    if (this.tabName == 'tabDevice') {
      this.showVideo()
    } else {
      this.showPoint()
    }
  }
  public showVideo() {
    if (this.$refs.videoCtrl) {
      this.$refs.videoCtrl.doSearch()
    }
  }
  public showPoint() {
    if (this.$refs.pointCtrl) {
      this.$refs.pointCtrl.doSearch()
    }
  }
  public beforeDestroy() {
  }
}
